

import React, { useMemo } from 'react';
import Box from '@mui/material/Box';
import { reduxForm } from 'redux-form';
import { useDispatch, useSelector } from "react-redux";
import Button from '@mui/material/Button';
import FormBuilder, { IMedAppFormField } from '../../../../../form';
import { SubscriptionTier } from '../../../../../../models';
import { required, minLength,  minValue as min, minValue } from '../../../../../form/utils/validations';
import { selectCreatingModel } from '../../../../store/selectors';
import LinearProgress from '@mui/material/LinearProgress';
import { useMutation, useQuery } from 'react-query';
import Api from '../../../../../../api/medAppApi';
import { ViewRequest } from '../../../../../../api/medAppApi';
import { useParams } from 'react-router';
import { putMessage } from '../../../../../app/store/actions';

const useSubscriptionTier = (id: number) => {

    const dispatch = useDispatch();
    
 
    const loadSubTier = async () => {
        const criteria: ViewRequest = {
            modelName: "subscriptiontier",
            modelId: id,
          };
        
        const response = await Api.viewModel<SubscriptionTier>(criteria)
        if(response.code === 200) {
            return response.data!.data.payload!
        } else {
            throw new Error(response.error || 'Something went wrong')
        }
    }
    return useQuery({
        queryFn: loadSubTier,
        queryKey: ['subscriptiontier', id],
        onError: (err: any) => {
            dispatch(putMessage({
                type: 'error',
                message: err?.message || 'Something went wrong'
            }))
        }
    })
}


const useUpdateSubscriptionTier = (id: number) => {
    const dispatch = useDispatch();
    const updateTier = async (data: any) => {
        const response = await Api.updateModel<SubscriptionTier>({
            modelName: "subscriptiontier",
            where: {id},
            update: data.payload
        })
        if(response.code === 200 || response.code === 201) {
            return response.data!.data.model!
        } else {
            throw new Error(response.error || 'Something went wrong')
        }
    }

    return useMutation({
        mutationFn: updateTier,
        mutationKey: 'update-subscriptiontier',
        onSuccess: () => {
            dispatch(putMessage({
                type: 'success',
                message: 'Successfully updated subscription tier'
            }))
        },
        onError: (err: any) => {
            dispatch(putMessage({
                type: 'error',
                message: err?.message || 'Something went wrong'
            }))
        }
    })
}
const intervals = ['days/d', 'months/m', 'years/y'].map(v => {
    const values = v.split('/');
    return {
        label: values[0],
        value: values[1],
    }
});


const SubscriptionTierUpdateForm: React.FC<any> = ({ mFields, name, handleSubmit, onSubmit }) => {

    const handleSubmitCallback = (value: any) => {
        onSubmit(value);
    };
    return (
        <form onSubmit={handleSubmit(handleSubmitCallback)}>  <FormBuilder fields={mFields} name={name} />
            <Button type="submit" variant="contained">Continue</Button>
        </form>);
}

const SubscriptionTierUpdateReduxForm = reduxForm<any, any>({
    form: 'subscriptiontier-update',
})(SubscriptionTierUpdateForm);


const SubscriptionTierUpdate: React.FC<{

}> = () => {
 
    const dispatch = useDispatch();
      let { id } = useParams<{ id: string }>();
    const {data: subscriptionTier, isLoading} = useSubscriptionTier(parseInt(id!))

    const {mutate: updateTier, isLoading: updating} = useUpdateSubscriptionTier(parseInt(id!))
    const creating = useSelector(selectCreatingModel('subscriptiontier'));

    const fields: IMedAppFormField[] = useMemo(() => [
        {
            name: 'price',
            label: 'Price',
            type: 'number',
            validate: [required, min(1000)],
           inputExtras: {
            defaultValue: subscriptionTier?.price
           }

        },
        {
            name: 'name',
            label: 'Subscription Tier Name',
            type: 'text',
            validate: [required, minLength(2)],
            defaultValue: subscriptionTier?.name

        },
        {
            name: 'divider',
        
            type: 'text',
            variant: 'divider',
        },
        {
            name: 'description',
            label: 'Subscription Tier Description',
            type: 'text',
            inputExtras: {
                multiline: true,
            },
            validate: [required, minLength(2)],
        

        

        },

        {
            name: 'subInterval',
            label: 'Subscription Interval',
            type: 'text',
            childFields: [
                {
                    variant: 'select',
                    inputExtras: intervals,
                    name: 'intervalType',
                    defaultValue: 'y',
                    label: 'Interval Type',
                    type: 'text',
              
                },

                {
                    name: 'interval',
                    placeholder: '1',
                    label: 'Interval',
                    validate: [required, minValue(1)],
                    type: 'number',
                   inputExtras: { defaultValue: subscriptionTier?.interval || 1}
                }
            ]
        },
        {
            name: 'maxMembers',
            label: 'Maximum users',
            type: 'number',
            validate: [minValue(1), required],
            inputExtras: {
                defaultValue: 1
            }
        },


   

 
        
    ], [subscriptionTier]);


    
    const handleSubmit = (value: any) => {
        const data = {...value, interval: parseInt(value.subInterval.interval, 10), intervalType: value.subInterval.intervalType || 'y'}
        delete data.subInterval;
        data.Status = 1;
        updateTier({payload: data})
    }

    
    return (
        <Box style={{
            width: '100%'
        }}>
            <Box sx={{
                width: '70%',
                maxWidth: '700px',
                minWidth: '250px',
                marginLeft: '1em'
            }}>
                {(updating || isLoading) && <LinearProgress />}
                <SubscriptionTierUpdateReduxForm mFields={fields} namel="kosy-2" onSubmit={handleSubmit} />
            </Box>
        </Box>
    )
};

export default SubscriptionTierUpdate;